/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcMutualfundsV1MutualFundsJobEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_MUTUALFUNDS_V1_MUTUAL_FUNDS_JOB_EVENT_ENTITY_NAME = 'ixc.mutualfunds.v1.MutualFundsJobEvent';
export const ixcMutualfundsV1MutualFundsJobEventEntity = new schema.Entity<IxcMutualfundsV1MutualFundsJobEvent>(IXC_MUTUALFUNDS_V1_MUTUAL_FUNDS_JOB_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcMutualfundsV1MutualFundsJobEvent) => `${entity.metadata?.eventId}` });

